<template>
  <content-dialog
    v-model="dialogOpen"
    fullscreen-mobile
    no-backdrop-dismiss
    title="Edit Account"
    width="700px"
    :card-visible="!!user"
    :tags="[helpCodes.createStaff, helpCodes.staff]"
    @hide="close"
  >
    <q-list
      v-if="!!user"
      dense
      padding
    >
      <AccountDetailsPartial
        :user="user"
        :old-email="oldEmail"
        :has-changed-email="hasChangedEmail"
        :errors="errors"
        :name-spacing="nameSpacing"
        edit-mode
      />
      <RolesPermissionsPartial
        :user="user"
        :errors="errors"
        :name-spacing="nameSpacing"
      />
    </q-list>

    <template #bottom>
      <q-toolbar v-if="!!user">
        <q-space />
        <q-btn
          color="green"
          icon-right="done"
          label="Save"
          @click="onClickSave"
        />
      </q-toolbar>
    </template>

    <!-- Password validation required if user is changing email -->
    <validate-password
      ref="passwordDialog"
      autocomplete
      @validated="saveUser"
    />
  </content-dialog>
</template>

<script>
import RolesPermissionsPartial from './panels/RolesPermissions'
import AccountDetailsPartial from './panels/AccountDetails'

export default {
  components: {
    RolesPermissionsPartial, AccountDetailsPartial
  },
  emits: ['close', 'saved'],
  data () {
    return {
      dialogOpen: false,
      user: null,
      errors: {},
      nameSpacing: 170,
      oldEmail: null
    }
  },
  computed: {
    hasChangedEmail () {
      return this.oldEmail && this.user && (this.user.email || '').length > 0 && this.oldEmail !== this.user.email
    }
  },
  methods: {
    open (obj) {
      this.user = JSON.parse(JSON.stringify(obj))
      this.oldEmail = obj.email
      this.dialogOpen = true
    },
    close () {
      this.user = null
      this.oldEmail = null
      this.$emit('close')
    },
    onClickSave () {
      if (this.hasChangedEmail) {
        this.$refs.passwordDialog.open()
      }
      else {
        this.saveUser()
      }
    },
    async saveUser (token = null) {
      this.errors = {}
      this.$loading.show()
      const { status, payload, errors } = await this.$put('v1/business/company/users', {
        ...this.user,
        email: this.hasChangedEmail ? this.user.email : null,
        password: token
      })
      this.$loading.hide()
      if (status === 'success') {
        if (payload.requested_new_email) {
          this.$q.dialog({
            title: 'Verify Email',
            message: this.user.name + ' will need to check their inbox for a verification email from ' + this.siteName + ' and follow the link to verify their account. Their current email address will remain active until the new email address has been verified.'
          })
        }

        this.dialogOpen = false
        this.$emit('saved')
        this.$q.notify({
          message: 'Account successfully updated',
          color: 'green'
        })
        this.$bus.emit('staff:reload', true)
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    }
  }
}
</script>
